import axios from "axios";
import { getBearerToken } from "../Authentication/Auth";
import { ErrorManagement } from "./ErrorManagement";
import { loaderType, StartLoader, StopLoader } from "./Loader";

let loader = loaderType.BUTTON;
let loaderText = "";

export function SwitchLoader(type, customText = "") {
  loader = type;
  loaderText = customText;
}

const Instance = axios.create({
  baseURL: process.env.REACT_APP_REGISTRATION_BASE_URL,
});

Instance.interceptors.request.use(
  (config) => {
    StartLoader(loader, loaderText);
    config.headers["Authorization"] = `Bearer ${getBearerToken().bearerToken}`;
    config.headers["From"] = "web";
    // debugger;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

Instance.interceptors.response.use(
  (response) => {
    StopLoader(loader);
    // debugger;
    return response.data;
  },
  (error) => {
    StopLoader(loader);
    // debugger;
    ErrorManagement(error);
    return Promise.reject(error);
  }
);

export default Instance;
